import { CompleteUmbrueckungDialogComponent } from './../component/complete-umbrueckung-dialog.component';
import { UmbrueckungDetails } from './../model/umbrueckung-details';
import { environment } from 'src/environments/environment';
import { BeginUmbrueckungDialogComponent } from '../component/begin-umbrueckung-dialog.component';
import { DialogService, HttpService } from '@sdbn/appclient';
import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { AsyncSubject } from 'rxjs';
import { DialogLayout } from 'src/app/shared/dialog-layout/dialog-layout';
import { ResponseStatus } from '@sdbn/appclient';
import { ServiceResponse } from '@sdbn/appclient';
import { TransportStationAssignment } from '../model/transport-station-assignment';


@Injectable({
  providedIn: 'root'
})
export class TransportUmbrueckungService {

  constructor(
    private httpService: HttpService,
    private dialogService: DialogService,
    private dialog: MatDialog) { }


  public completeTransportUmbrueckung(details: UmbrueckungDetails): AsyncSubject<void> {

    const result = new AsyncSubject<void>();

    const dialogRef = this.dialog.open(CompleteUmbrueckungDialogComponent, {
      maxHeight: '95vh',
      data: {
        details
      },
      panelClass: DialogLayout.panelClass,
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(
      r => {
        result.next();
        result.complete();
      }
    );

    return result;
  }

  public beginTransportUmbrueckung(assignment: TransportStationAssignment): AsyncSubject<void> {

    const result = new AsyncSubject<void>();

    this.httpService.postWithContext<ServiceResponse>(environment.transportUmbrueckungEndpoint + '', assignment).subscribe(
      details => {
        if (details.status !== ResponseStatus.SUCCESS) {

          const additionalMessageDictionaryKeys = new Array<string>();
          for (const message of details.responseMessages) {
            additionalMessageDictionaryKeys.push(message.dictionaryKey);
          }

          const ref = this.dialogService.showInfoDialog(
            'tmc-yard.ui.transport-umbrueckung.message-dialog-invalid-transport-title',
            'tmc-yard.ui.transport-umbrueckung.message-dialog-invalid-transport-message',
            additionalMessageDictionaryKeys
          );
          ref.afterClosed().subscribe(
            r => {
              result.next();
              result.complete();
            }
          );

        } else {
          const dialogRef = this.dialog.open(BeginUmbrueckungDialogComponent, {
            data: {
              details
            },
            panelClass: DialogLayout.panelClass,
            autoFocus: false
          });
          dialogRef.afterClosed().subscribe(
            r => {
              result.next();
              result.complete();
            }
          );
        }
      },
      error => {
        result.error('Error loading target transports');
        result.next();
        result.complete();
      }
    );

    return result;
  }
}

